import { ExpandableParagraph, Typography } from 'omakase';
import { consumer } from '@tock/coretypes';
import { cropImageUrl } from '@tock/images';
import { getLocality } from 'utils/businessUtils';
import Anchor from 'components/Anchor';
import BaseComponent from '@tock/shared/components/BaseComponent';
import LazyImage from '@tock/shared/components/LazyImage';

interface Props {
  business: consumer.OfferingBusiness;
  imageLink: string;
  showDescription?: boolean;
}

class RestaurantResult extends BaseComponent<Props> {
  handleTrackBookClick(): void {
    const { name } = this.props.business;
    window.analytics.sendEvent('discover-restaurants-book', 'click', name);
  }

  render() {
    const { business, imageLink, showDescription } = this.props;

    const description = business.description;
    const imgSrc = cropImageUrl(imageLink, 120, 120);
    const href = `/${business.domainName}?tock_source=tock&tock_medium=availability_search&tock_content=restaurant_box`;
    const locality = getLocality(business);
    const { neighborhood, cuisines, priceRange, name } = business;
    const subtitle = [locality, neighborhood, cuisines, priceRange].filter(Boolean).join(' · ');

    return (
      <Anchor
        className="AvailabilitySearch-resultLink"
        href={href}
        trackingCategory="discover-book"
        onClick={this.handleTrackBookClick}
      >
        <div className="AvailabilitySearch-restaurantContent">
          <Typography variant="heading02" component="h2" color="fgDefault">
            {name}
          </Typography>
          <Typography mb={showDescription ? 2 : 0} variant="body02" component="p" color="fgSubtle">
            {subtitle}
          </Typography>
          {description && showDescription && (
            <ExpandableParagraph paragraphText={description} linkify={true} />
          )}
        </div>
        <div className="AvailabilitySearch-imageContainer">
          <LazyImage alt={name} className="AvailabilitySearch-image" src={imgSrc} />
        </div>
      </Anchor>
    );
  }
}

export default RestaurantResult;
